export type SignedBy = { givenName: string; surname: string; title: string };

type Rec = Record<string, unknown>;
const rec = (v: unknown): Rec => (typeof v === 'object' && v !== null && !Array.isArray(v) ? (v as Rec) : {});
const s = (v: unknown): string => (typeof v === 'string' ? v : '');

export const emptySignedBy = (): SignedBy => ({ givenName: '', surname: '', title: '' });

export function signedByFilled(p: SignedBy): boolean {
  return Boolean(p.givenName.trim() || p.surname.trim() || p.title.trim());
}

function personFrom(v: unknown): SignedBy {
  const o = rec(v);
  return {
    givenName: s(o.givenName),
    surname: s(o.surname),
    title: s(o.title),
  };
}

/** Signer on Communicate xdis18/xdis21-prefill: top-level or sender.signedBy. */
export function signedByFromPrefill(prefill: Rec): SignedBy {
  const nested = rec(prefill.prefill);
  const sender = rec(prefill.sender);
  const nestedSender = rec(nested.sender);
  for (const raw of [prefill.signedBy, sender.signedBy, nested.signedBy, nestedSender.signedBy]) {
    const person = personFrom(raw);
    if (signedByFilled(person)) return person;
  }
  return emptySignedBy();
}

/** Last word is surname — same split as GGOP / the logged-in practitioner name. */
export function signedByFromPractitioner(name: string | null | undefined, title: string | null | undefined): SignedBy {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const givenName = parts.length > 1 ? parts.slice(0, -1).join(' ') : '';
  const surname = parts.length > 0 ? parts[parts.length - 1]! : '';
  return { givenName, surname, title: (title ?? '').trim() };
}

/** Keep a previous signer; otherwise use the logged-in practitioner. Fields stay editable. */
export function withSignedByFallback<T extends { signedBy: SignedBy }>(state: T, fallback: SignedBy): T {
  if (signedByFilled(state.signedBy) || !signedByFilled(fallback)) return state;
  return { ...state, signedBy: fallback };
}
